const defaultState = {
  data: [],
  loading: false,
  error: false,
};

// These correspond to the table on the backend and are hardcoded until it becomes hard to maintain
const alertTypes = {
  1: { name: "Site Distance", unit_name: "meters" },
  2: { name: "Response Inactivity", unit_name: "minutes" },
};

const alerts = function (state = defaultState, action) {
  switch (action.type) {
    case "SET_ALERTS":
      // set up the alert type information
      action.data.forEach((alert) => {
        alert.alert_type = alertTypes[alert.alert_type];
      });
      return { ...state, data: action.data };

    case "SET_ALERTS_LOADING":
      return {
        ...state,
        loading: action.data,
      };

    case "SET_ALERTS_ERROR":
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default alerts;
export { alertTypes };
